import { apiRequest } from "./apiClient";
import { stateChangingRequest } from "./authApi";

export function getUsers() {
  return apiRequest("/api/users");
}
export function createUser(user) {
  return stateChangingRequest("/api/users", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(user),
  });
}

export function updateUser(userId, user) {
  return stateChangingRequest(`/api/users/${encodeURIComponent(userId)}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(user),
  });
}

export function deleteUser(userId) {
  return stateChangingRequest(`/api/users/${encodeURIComponent(userId)}`, {
    method: "DELETE",
  });
}

export function updateUserStatus(userId, isActive) {
  return stateChangingRequest(
    `/api/users/${encodeURIComponent(userId)}/status`,
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ isActive }),
    },
  );
}

export function setPasswordChangeRequired(userId, required) {
  return stateChangingRequest(
    `/api/users/${encodeURIComponent(userId)}/password-change-required`,
    {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ required }),
    },
  );
}
